import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Card from '../../components/Card'
import Grid from '../../components/Grid'
import Toggle from '../../components/Toggle'
import patient from '../../stores/patient'

@observer
export default class SurgeriesForm extends Component {
  render() {
    return (
      <Card>
        <Card.Title str="titles.selectAllSurgeries" />
        <Card.Pad>
          <Grid>
            <Grid.HalfCell>
              <Toggle
                color="dark-blue"
                checked={patient.fields.surgeries.includes('DRAINAGE_IMPLANT')}
                str="choices.surgery.DRAINAGE_IMPLANT"
                onToggle={() => patient.toggleSurgery('DRAINAGE_IMPLANT')}
              />
            </Grid.HalfCell>
            <Grid.HalfCell>
              <Toggle
                color="dark-blue"
                checked={patient.fields.surgeries.includes('TRABECULECTOMY')}
                str="choices.surgery.TRABECULECTOMY"
                onToggle={() => patient.toggleSurgery('TRABECULECTOMY')}
              />
            </Grid.HalfCell>
            <Grid.HalfCell>
              <Toggle
                color="dark-blue"
                checked={patient.fields.surgeries.includes('ANGLE_SURGERY')}
                str="choices.surgery.ANGLE_SURGERY"
                onToggle={() => patient.toggleSurgery('ANGLE_SURGERY')}
              />
            </Grid.HalfCell>
            <Grid.HalfCell>
              <Toggle
                color="dark-blue"
                checked={patient.fields.surgeries.includes('IRIDOTOMY')}
                str="choices.surgery.IRIDOTOMY"
                onToggle={() => patient.toggleSurgery('IRIDOTOMY')}
              />
            </Grid.HalfCell>
            <Grid.HalfCell>
              <Toggle
                color="dark-blue"
                checked={patient.fields.surgeries.includes('TRABECULOPLASTY')}
                str="choices.surgery.TRABECULOPLASTY"
                onToggle={() => patient.toggleSurgery('TRABECULOPLASTY')}
              />
            </Grid.HalfCell>
            <Grid.HalfCell>
              <Toggle
                color="dark-blue"
                checked={patient.fields.surgeries.includes('CTLC')}
                str="choices.surgery.CTLC"
                onToggle={() => patient.toggleSurgery('CTLC')}
              />
            </Grid.HalfCell>
          </Grid>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/SurgeriesForm.js